export const passwordCheck = (password: string): string => {
  let strength = 0;

  // password length
  if (password.length >= 8) {
    strength += 1;
  }

  // mixed case
  if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
    strength += 1;
  }

  // look for numbers
  if (password.match(/\d/)) {
    strength += 1;
  }

  // look for special chars
  if (password.match(/[^a-zA-Z\d]/)) {
    strength += 1;
  }

  if (strength < 3) {
    return 'weak';
  } else if (strength < 4) {
    return 'medium';
  } else {
    return 'strong';
  }
};
